import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import './Pix.css';

function Pix() {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = useMemo(() => [
    { src: '/images/01-ZoePeteFord-03.jpg', alt: 'Zoe Pete Ford' },
    { src: '/images/01-ZoePeteFord-07.jpg', alt: 'Zoe Pete Ford' },
    { src: '/images/DSCI0464 2.jpg', alt: 'Live performance' },
    { src: '/images/F97E5916-C840-4FEC-B0D6-F432DDF0B918.JPG', alt: 'Live performance' },
    { src: '/images/Screenshot 2025-08-13 at 3.51.31 PM.png', alt: 'Live performance' },
    { src: '/images/tyler pic from bbq 2(2).png', alt: 'Tyler at BBQ' },
    { src: '/images/presspage.png', alt: 'Press page' },
    { src: '/images/IMG_6102.jpeg', alt: 'Performance at Skinny Dennis' },
    { src: '/images/IMG_1766.JPG', alt: 'Live performance' },
    { src: '/images/IMG_1758.JPG', alt: 'Live performance' },
    { src: '/images/IMG_1764.JPG', alt: 'Live performance' },
    { src: '/images/IMG_1769.JPG', alt: 'Live performance' },
    { src: '/images/sleepwalk poster.JPEG', alt: 'Sleepwalk Poster' },
    { src: '/images/TY_04758.JPEG', alt: 'Live performance' },
    { src: '/images/DSC_0958.JPEG', alt: 'Live performance' },
    { src: '/images/jones bar 10.PNG', alt: 'Performance at Jones Bar' },
    { src: '/images/IMG_7274.JPEG', alt: 'Live performance' },
    { src: '/images/what.JPEG', alt: 'Live performance' },
    { src: '/images/unnamed.PNG', alt: 'Live performance' },
    { src: '/images/cpm35 2024-11-22 215757.735.JPG', alt: 'Live performance' },
    { src: '/images/jones bar4.PNG', alt: 'Performance at Jones Bar' },
    { src: '/images/Screenshot 2024-10-15 at 15.45.31.JPEG', alt: 'Live performance' },
    { src: '/images/LUNA3563.JPEG', alt: 'Live performance' },
    { src: '/images/IMG_0954.JPG', alt: 'Live performance' },
    { src: '/images/IMG_3781.PNG', alt: 'Live performance' }
  ], []);

  const handlePrevious = useCallback((e) => {
    e.stopPropagation();
    const currentIndex = images.findIndex(img => img.src === selectedImage.src);
    const previousIndex = (currentIndex - 1 + images.length) % images.length;
    setSelectedImage(images[previousIndex]);
  }, [selectedImage, images]);

  const handleNext = useCallback((e) => {
    e.stopPropagation();
    const currentIndex = images.findIndex(img => img.src === selectedImage.src);
    const nextIndex = (currentIndex + 1) % images.length;
    setSelectedImage(images[nextIndex]);
  }, [selectedImage, images]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      if (e.key === 'ArrowLeft') {
        handlePrevious(e);
      } else if (e.key === 'ArrowRight') {
        handleNext(e);
      } else if (e.key === 'Escape') {
        setSelectedImage(null);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, handleNext, handlePrevious]);

  const Modal = () => {
    if (!selectedImage) return null;

    return createPortal(
      <div className="modal-wrapper">
        <div className="modal-backdrop" onClick={() => setSelectedImage(null)} />
        <div className="modal">
          <button className="nav-button prev" onClick={handlePrevious}>‹</button>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={() => setSelectedImage(null)}>×</button>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="modal-image"
            />
          </div>
          <button className="nav-button next" onClick={handleNext}>›</button>
        </div>
      </div>,
      document.body
    );
  };

  return (
    <div className="pix-container">
      <div className="image-grid">
        {images.map((image, index) => (
          <div 
            key={index} 
            className="image-item"
            onClick={() => setSelectedImage(image)}
          >
            <img
              src={image.src}
              alt={image.alt}
              loading="lazy"
              style={{ display: 'block' }}
              onError={(e) => {
                console.error(`Failed to load image: ${image.src}`);
                e.target.style.display = 'none';
              }}
            />
          </div>
        ))}
      </div>
      <Modal />
    </div>
  );
}

export default Pix;